// Generated by https://quicktype.io

import { ApiMessage } from 'projects/ppb-shared-library/src/lib/models/global.model';

export enum AccountIalEnum {
  LOW = 'LOW', MEDIUM = 'MEDIUM', HIGH = 'HIGH'
}

export const enum AccountStatusEnum {
  ACTIVE = 'ACTIVE', INACTIVE = 'INACTIVE', BLOCKED = 'BLOCKED', DISABLED = 'DISABLED'
}

export enum AccountFactorsEnum {
  VOICE_TONE, PHOTO, OTHER
}

export enum AccountDocumentsEnum {
  ID_CARD, PASSPORT, CORPORATE_ID_CARD, DRIVING_LICENSE, OTHER
}

export enum AccountStatusTypeEnum {
  USER_REQUEST, INACTIVE_USER, BY_OPERATOR
}

export enum AccountHistoryResourceLogTypeEnum {
  ACCOUNT_CREATED,
  ACCOUNT_STATUS_CHANGE,
  EMAIL_SENT,
  LOGIN_SUCCESSFUL,
  NO_ACTIVITY,
  PERSONAL_DATA_CHANGED,
  ROLE_ASSIGMENT,
  SMS_SENT,
  VERIFICATION_LEVEL_CHANGE
}

export interface AccountDetailsModel {
  id?: string;
  email?: string;
  expectedIal?: AccountIalEnum;
  firstName?: string;
  ial?: AccountIalEnum;
  lockType?: string;
  lastName?: string;
  lockDate?: Date;
  lockReason?: string;
  phone?: {
    number: string;
    prefix: string
  };
  registrationDate?: Date;
  sharePhone?: boolean;
  status?: keyof typeof AccountStatusEnum;
  messages?: ApiMessage[]
}
